<template>
  <pt-holiday-form class="pt-holiday-form__page"></pt-holiday-form>
</template>

<script>
import PtHolidayForm from 'cps/lab-order/pt-holiday-manage/pt-holiday-form/withData'
export default {
  name: 'pt-holiday-form__view',
  components: {
    'pt-holiday-form': PtHolidayForm
  }
}
</script>
